import { datadogRum } from "@datadog/browser-rum";
import shallow from "zustand/shallow";

import useAppStore from "src/stores/appStore";

const getRumGlobalContext = state => ({
  userId: state.userPermissions?.userId,
  accountId: state.selectedAccountId,
  assistantId: state.selectedAssistant?.assistantId,
  assistantName: state.selectedAssistant?.assistantName,
  assistantChannel: state.selectedAssistant?.channel,
  assistantFolder: state.selectedAssistant?.assistantFolder
});

let unsubscribeRumContextSync;

const syncRumGlobalContext = () => {
  unsubscribeRumContextSync?.();
  unsubscribeRumContextSync = useAppStore.subscribe(getRumGlobalContext, context => datadogRum.setGlobalContext(context), {
    equalityFn: shallow,
    fireImmediately: true
  });
};

const initDatadog = () => {
  datadogRum.init({
    applicationId: import.meta.env.VITE_DATADOG_DASHBOARD_RUM_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DATADOG_DASHBOARD_RUM_CLIENT_TOKEN,
    site: "datadoghq.com",
    service: import.meta.env.VITE_DATADOG_DASHBOARD_RUM_SERVICE_NAME,
    env: import.meta.env.VITE_ENV,
    version: import.meta.env.VITE_CI_COMMIT_SHORT_SHA,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    defaultPrivacyLevel: "allow",
    allowedTracingUrls: [import.meta.env.VITE_DASHBOARD_API_URL],
    traceSampleRate: 100
  });

  datadogRum.startSessionReplayRecording();
  syncRumGlobalContext();
};

export default initDatadog;
